import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { ArrayList3it5z8td81qkl as ArrayList } from '../../../../../../kotlin-kotlin-stdlib/kotlin/collections/ArrayListJs.mjs';
import {
  RequestHook_instance3dpz39ekmwtkx as RequestHook_instance,
  TransformRequestBodyHook_instance2rtk49v5zeoj1 as TransformRequestBodyHook_instance,
  TransformResponseBodyHook_instance11jxsj1c494hm as TransformResponseBodyHook_instance,
} from './KtorCallContexts.mjs';
import { HookHandler356pvj77mag23 as HookHandler } from './ClientHook.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function ClientPluginBuilder$onClose$lambda() {
  return Unit_instance;
}
var ClientPluginBuilderClass;
function ClientPluginBuilder() {
  if (ClientPluginBuilderClass === VOID) {
    class $ {
      constructor(key, client, pluginConfig) {
        this.p5p_1 = key;
        this.q5p_1 = client;
        this.r5p_1 = pluginConfig;
        var tmp = this;
        // Inline function 'kotlin.collections.mutableListOf' call
        tmp.s5p_1 = ArrayList().p2();
        var tmp_0 = this;
        tmp_0.t5p_1 = ClientPluginBuilder$onClose$lambda;
      }
      s5t(block) {
        this.u5p(RequestHook_instance, block);
      }
      l5v(block) {
        this.u5p(TransformRequestBodyHook_instance, block);
      }
      j5s(block) {
        this.u5p(TransformResponseBodyHook_instance, block);
      }
      u5p(hook, handler) {
        this.s5p_1.j2(new (HookHandler())(hook, handler));
      }
    }
    initMetadataForClass($, 'ClientPluginBuilder');
    ClientPluginBuilderClass = $;
  }
  return ClientPluginBuilderClass;
}
//region block: exports
export {
  ClientPluginBuilder as ClientPluginBuilder3nx9qxmpfnzts,
};
//endregion

//# sourceMappingURL=ClientPluginBuilder.mjs.map
